import { useEffect, useState } from "react";
import { Package, Plus, Check } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { useCart } from "../../context/CartContext";
import { Reveal } from "./Reveal";

export const FreeBox = () => {
  const [box, setBox] = useState(null);
  const [added, setAdded] = useState(false);
  const { addItem, setOpen } = useCart();

  useEffect(() => {
    api.get("/freebox").then((r) => setBox(r.data)).catch(() => {});
  }, []);

  if (!box || box.items.length === 0) return null;

  const addBox = () => {
    box.items.forEach((i) => addItem(i, i.quantity));
    setAdded(true);
    toast.success("FreeBox di prova aggiunta al carrello!");
    setOpen(true);
    setTimeout(() => setAdded(false), 2500);
  };

  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-8 pb-20 lg:pb-28" data-testid="freebox-section">
      <Reveal>
        <div className="relative rounded-[2rem] bg-[#2E8A57] text-[#FDFBF7] overflow-hidden">
          <div className="absolute -top-16 -right-16 w-64 h-64 rounded-full bg-[#7DC242]/20 blur-2xl" />
          <div className="grid lg:grid-cols-2 gap-10 p-8 lg:p-14 items-center">
            <div>
              <p className="font-mono-accent text-xs uppercase tracking-[0.3em] text-[#7DC242] mb-4 flex items-center gap-2">
                <Package className="w-4 h-4" /> Prova tutti i classici
              </p>
              <h2 className="font-serif-display font-bold text-3xl sm:text-4xl tracking-tight">
                FreeBox di prova
              </h2>
              <p className="mt-4 text-[#FDFBF7]/80 leading-relaxed max-w-md">
                {box.items.length} primi piatti gluten free del nostro menu, {box.quantity_each} porzioni ciascuno.
                La selezione perfetta per scoprire la cucina di Chef Michel — e supera subito l'ordine minimo.
              </p>
              <div className="mt-7 flex items-center gap-5 flex-wrap">
                <button
                  data-testid="add-freebox-btn"
                  onClick={addBox}
                  className="inline-flex items-center gap-2 px-8 py-4 rounded-full font-semibold text-sm bg-[#FDFBF7] text-[#2E8A57] hover:bg-[#7DC242] hover:text-[#243329] transition-colors duration-300"
                >
                  {added ? <Check className="w-4 h-4" /> : <Plus className="w-4 h-4" />}
                  {added ? "Aggiunta!" : "Aggiungi FreeBox al carrello"}
                </button>
                <span data-testid="freebox-total" className="font-serif-display font-bold text-2xl">
                  {box.total.toFixed(2).replace(".", ",")} €
                </span>
              </div>
            </div>
            <div className="grid grid-cols-4 gap-2.5">
              {box.items.slice(0, 8).map((i) => (
                <div key={i.slug} className="relative rounded-xl overflow-hidden aspect-square border border-white/15">
                  <img src={i.image} alt={i.name} loading="lazy" className="w-full h-full object-cover" />
                </div>
              ))}
              {box.items.length > 8 && (
                <div className="col-span-4 text-center font-mono-accent text-[11px] uppercase tracking-[0.2em] text-[#FDFBF7]/60 pt-1">
                  + altri {box.items.length - 8} piatti · {box.quantity_each} porzioni ciascuno
                </div>
              )}
            </div>
          </div>
        </div>
      </Reveal>
    </section>
  );
};
